<template>
  <section>
    <br />
    <div class="columns is-mobile is-centered">
      <div class="column is-half">
        <div class="card" style="width: 750px">
          <header class="card-header">
            <p class="card-header-title">Registreren</p>
          </header>
          <div class="card-content" ref="cardRef">
            <div class="field is-horizontal">
              <div class="field-label is-small">
                <label class="label">Voornaam</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control is-expanded has-icons-left">
                    <input class="input" type="text" placeholder="Typ hier uw voornaam..." v-model="user.FirstName" />
                    <span class="icon is-small is-left">
                      <i class="fas fa-user"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-small">
                <label class="label">Achternaam</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control is-expanded has-icons-left">
                    <input class="input" type="text" placeholder="Typ hier uw achternaam..." v-model="user.LastName" />
                    <span class="icon is-small is-left">
                      <i class="fas fa-user"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-small">
                <label class="label">Email-adres</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control is-expanded has-icons-left">
                    <input
                      class="input"
                      type="email"
                      id="mail"
                      placeholder="Typ hier uw email-adres..."
                      v-model="user.Email"
                      required
                    />
                    <span class="icon is-small is-left">
                      <i class="fas fa-envelope"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal">
              <div class="field-label is-small">
                <label class="label">Wachtwoord</label>
              </div>
              <div class="field-body">
                <div class="field has-addons">
                  <div class="control is-expanded has-icons-left">
                    <div class="password">
                      <input
                        :class="'input ' + { valid: passwordValidation.valid }"
                        :type="passwordVisible ? 'text' : 'password'"
                        v-model="user.Password"
                        placeholder="Typ hier uw wachtwoord..."
                      />
                      <span class="icon is-small is-left">
                        <i class="fas fa-lock"></i>
                      </span>
                    </div>
                  </div>
                  <div class="control">
                    <button
                      class="button visibility"
                      tabindex="-1"
                      @click="togglePasswordVisibility"
                      :arial-label="passwordVisible ? 'Hide password' : 'Show password'"
                    >
                      <span class="icon is-small is-left">
                        <i :class="passwordVisible ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="field is-horizontal">
              <div class="field-label is-small">
                <label class="label">Herhaal Wachtwoord</label>
              </div>
              <div class="field-body">
                <div class="field">
                  <div class="control is-expanded has-icons-left">
                    <input
                      class="input"
                      type="password"
                      v-model.lazy="checkPassword"
                      placeholder="Herhaal nog eens uw wachtwoord"
                    />

                    <span class="icon is-small is-left">
                      <i class="fas fa-lock"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="field is-horizontal" v-if="user.Password != null && passwordValidation.errors.length > 0">
              <div class="field-label is-small">
                <label class="label"></label>
              </div>
              <div class="field-body">
                <b-message
                  title="Het wachtwoord is nog niet correct"
                  type="is-danger"
                  size="is-small"
                  style=" width: -webkit-fill-available;"
                >
                  <div class="content is-danger">
                    <transition name="hint" appear>
                      <div v-if="passwordValidation.errors.length > 0 && !submitted" class="hints">
                        <p class="hint" v-for="error in passwordValidation.errors" :key="error.id">{{ error }}</p>
                      </div>
                    </transition>

                    <div class="matches" v-if="notSamePasswords">
                      <p>Passwords don't match.</p>
                    </div>
                  </div>
                </b-message>
              </div>
            </div>
            <div class="field is-horizontal is-grouped is-grouped-right">
              <div class="field-label is-small">
                <label class="label"></label>
              </div>
              <div class="field-body">
                <div class="control">
                  <b-checkbox v-model="user.AcceptsTerms" type="is-success"
                    >Druk hier om de voorwaarde te accepteren</b-checkbox
                  >
                </div>
              </div>
            </div>
            <div class="field is-horizontal" v-if="errormsg.length != 0">
              <div class="field-label is-small">
                <label class="label"></label>
              </div>
              <div class="field-body">
                <b-message
                  title="Er is iets fout gegaan"
                  type="is-danger"
                  size="is-small"
                  style=" width: -webkit-fill-available;"
                >
                  <div class="content is-danger">
                    <transition name="hint" appear>
                      <div v-if="errormsg.length > 0" class="hints">
                        <p class="hint" v-for="error in errormsg" :key="error.id">{{ error }}</p>
                      </div>
                    </transition>
                  </div>
                </b-message>
              </div>
            </div>
            <div class="field is-horizontal is-grouped is-grouped-right">
              <div class="field-label is-small">
                <label class="label"></label>
              </div>
              <div class="field-body">
                <div class="buttons is-right">
                  <button @click="$router.push('/login')" class="button">Annuleer</button>
                  <!-- </div>
                  <div class="control">-->
                  <button @click="register()" class="button is-primary">Registreer</button>
                </div>
              </div>
            </div>
            <div class="field is-horizontal" v-if="succes">
              <div class="field-body">
                <div class="field">
                  <div class="control">
                    <br />
                    <b-message title="Success" type="is-success"
                      >Succesvol Geregistreerd, kijk in uw mailbox voor een bevestigings email (check ook de
                      spamfolder).</b-message
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import userService from '@/services/userService.js'

export default {
  data() {
    return {
      user: { FirstName: '', LastName: '', Email: '', Password: null, AcceptsTerms: false },
      rules: [
        { id: 1, message: 'One lowercase letter required.', regex: /[a-z]+/ },
        { id: 2, message: 'One uppercase letter required.', regex: /[A-Z]+/ },
        { id: 3, message: '8 characters minimum.', regex: /.{8,}/ },
        { id: 4, message: 'One number required.', regex: /[0-9]+/ }
      ],
      checkPassword: '',
      passwordVisible: false,
      submitted: false,
      errormsg: [],
      succes: false
    }
  },
  computed: {
    notSamePasswords() {
      if (this.passwordsFilled) {
        return this.user.Password !== this.checkPassword
      }
      return false
    },
    passwordsFilled() {
      return this.user.Password !== '' && this.checkPassword !== ''
    },
    passwordValidation() {
      const errors = []
      for (const condition of this.rules) {
        if (!condition.regex.test(this.user.Password)) {
          errors.push(condition.message)
        }
      }
      if (errors.length === 0) {
        return { valid: true, errors }
      }
      return { valid: false, errors }
    }
  },
  methods: {
    resetPasswords() {
      this.user.Password = ''
      this.checkPassword = ''
      this.submitted = true
      setTimeout(() => {
        this.submitted = false
      }, 2000)
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible
    },
    register() {
      this.errormsg = []
      const inputs = this.$refs.cardRef.getElementsByTagName('input')
      let empty = false
      if (!this.passwordValidation.valid) this.errormsg.push('Uw wachtwoord is niet correct')
      if (this.user.Password != this.checkPassword) this.errormsg.push('Uw wachtwoorden komen niet overeen')
      for (let i = 0; i < inputs.length; i++) {
        if (inputs[i].type == 'checkbox')
          if (!inputs[i].checked) this.errormsg.push('Accepteer de voorwaarde alstublieft')
        if (inputs[i].className == 'input' && !empty)
          if (inputs[i].value == '') this.errormsg.push('Niet alle velden zijn gevuld'), (empty = true)
        if (inputs[i].type == 'email')
          if (inputs[i].validity.valid == false)
            this.errormsg.push('Uw email-adres is incorrect (voorbeeld: voorbeeld@firestopdoc.com)')
      }
      if (this.errormsg.length == 0) {
        userService
          .registerUser(JSON.stringify(this.user))
          .then(res => {
            if (res.status == 200) {
              this.succes = true
              setTimeout(() => {
                this.$router.push('/login')
              }, 4000)
            }
          })
          .catch(ex => {
            if (ex.response.status == 400) {
              this.errormsg.push(
                'Deze gebruiker bestaat al! Kijk in uw e-mail inbox om uw account te activeren of neem contact op met de beheerder via het help contact formulier'
              )
            } else if (ex.response.status == 200) {
              this.succes = true
              setTimeout(() => {
                this.$router.push('/login')
              }, 2000)
            }
          })
      }
    }
  }
}
</script>

<style lang="css" scoped>
.hints {
  width: 100%;
}
.content p:not(:last-child) {
  margin-bottom: 0px;
  padding: 0px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/AuthRegister.vue